const FORGOT_PASSWORD_STEP = {
  RESET_PASSWORD: "reset_password",
  CONFIRM_CODE: "confirm_code",
  SUCCESS: "success",
};

export default FORGOT_PASSWORD_STEP;
